"use client";

import type { NavDecorationProps } from "@/components/decorations/types";

/**
 * HalloweenNav
 *
 * Navigation decorations for Halloween theme (ghost images).
 * Part of the decoration system - controlled via NEXT_PUBLIC_ACTIVE_DECORATIONS.
 *
 * Renders ghost images in the navigation header based on placement prop.
 */
export function HalloweenNav({ placement }: NavDecorationProps) {
  // Left ghost (next to logo)
  if (placement === "left") {
    return (
      <img
        src="/images/halloween/NavGhost.webp"
        alt=""
        aria-hidden="true"
        width={34}
        height={40}
        className="h-10 w-auto pointer-events-none select-none"
      />
    );
  }

  // Right ghost (in navigation menu)
  if (placement === "right") {
    return (
      <img
        src="/images/halloween/NavGhost.webp"
        alt=""
        aria-hidden="true"
        width={34}
        height={40}
        className="h-10 w-auto pointer-events-none select-none -scale-x-100"
      />
    );
  }

  // If no placement specified, don't render anything
  // This ensures explicit placement is required
  return null;
}
